// See: https://web.dev/articles/vitals
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      // Cumulative Layout Shift (CLS): measures visual stability. To provide a good user experience,
      // pages should maintain a CLS of 0.1. or less.
      onCLS(onPerfEntry);
      // Interaction to Next Paint (INP): measures interactivity. To provide a good user experience,
      // pages should have a INP of 200 milliseconds or less.
      onINP(onPerfEntry);
      // First contentful Paint (FCP)
      onFCP(onPerfEntry);
      // Largest Contentful Paint (LCP): measures loading performance. To provide a good user experience,
      // LCP should occur within 2.5 seconds of when the page first starts loading.
      onLCP(onPerfEntry);
      // Time To First Byte (TTFB)
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
